<template>
  <div>
    <div class="relevant" ref="relevant">
      <!-- <h1 @click="addCalss()">遗传易感相关变异</h1>
      <div class="show-box"></div> -->

      <div class="text-content">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text=""
          @load="onLoad"
        >
          <div class="byData" v-for="(item, index) in byDataList" :key="index">
            <h2>
              {{ item.geneName }}
              <span @click="embryoDetails(item)"
                >解读 <van-icon name="arrow"
              /></span>
            </h2>
            <div class="show-box"></div>
            <div class="flex-content">
              <div class="l">
                <div>
                  <p>致病风险</p>
                  <van-tag
                    :color="color[item.genetronInfChinese]"
                    :text-color="textColor[item.genetronInfChinese]"
                    size="medium"
                    >{{ item.genetronInfChinese }}</van-tag
                  >
                </div>
                <div>
                  <p>氨基酸</p>
                  <h3>{{ item.proteinChange }}</h3>
                </div>
              </div>
              <div class="r">
                <div>
                  <p>核苷酸</p>
                  <h3>{{ item.cdnaChange }}</h3>
                </div>
                <div>
                  <p>纯合/杂合</p>
                  <h3>{{ item.homHetChinese }}</h3>
                </div>
              </div>
            </div>
          </div>
        </van-list>
        <div class="null-box" v-if="isEmpty">
          <van-empty
            class="custom-image"
            :image="require('../../../../assets/null-data.png')"
            description="暂无数据"
          />
        </div>
        <div class="zhushi">
          <h2>注释</h2>
          <div class="show-box"></div>
          <div class="text">
            {{ notesText }}
          </div>
        </div>
        <div class="_btn" @click="handleDetails()">
          胚系变异检出详情<i class="iconfont icon-right_medium"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { embryo } from "@/api/reportQuery";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
import { Toast } from "vant";
import isiOS from "@/utils/iosAn";

export default {
  data() {
    return {
      isEmpty: false,
      isClass: false,
      loading: false,
      finished: false,
      byDataList: [],
      // 遗传易感相关变异数据
      color: {
        致病: "#FFF0F3",
        可能致病: "#FFF8EE",
        意义未明: "#F4F1FF",
      },
      textColor: {
        致病: "#FF627F",
        可能致病: "#FFB026",
        意义未明: "#7C67E6",
      },
      notesText: "",
      // labOriginalSampleNo:"F210422168T",
      // productId:"fwa-p825"
    };
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  mounted() {
    window.NativeCallJS = (res) => {
      var par = JSON.parse(res);
      console.log(par, "00000000011111");
      this.notesText = par.notes
    };
  },
  methods: {
    ...mapMutations("embry", ["setParams"]),
    handleDetails() {
      let params = {
        name: "embryoAll",
        type: "",
      };
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(params);
      } else {
        window.android.JSCallNative(JSON.stringify(params));
      }
    },
    isNotes() {
      // this.notesText = {
      //   h1: "遗传易感相关变异注释1122",
      //   p: "克唑替尼*+雷莫芦单抗/贝伐",
      // };
      this.$refs.child.ishow();
    },
    addCalss() {
      this.isClass = !this.isClass;
    },
    onLoad() {
      this.getfindGermline();
    },
    /**遗传易感相关变异接口 */
    async getfindGermline() {
      try {
        let { data } = await embryo({
          labOriginalSampleNo: this.$route.query.fname,
          productId: this.$route.query.fid,
        });
        setTimeout(() => {
          if (data.records.length > 10) {
            for (let i = 0; i <= 10; i++) {
              this.byDataList.push(data.records[i]);
            }
          } else {
            this.byDataList = data.records;
          }
          if (data.records == "") {
            this.isEmpty = true;
          } else {
            this.isEmpty = false;
          }
          // 加载状态结束
          this.loading = false;
          this.finished = true;
          // 数据全部加载完成
          if (this.byDataList.length >= data.length) {
            this.finished = true;
          }
        }, 1000);
      } catch (error) {
        Toast(error.message);
      }
    },
    embryoDetails(item) {
      let param = {
        name: "embryoDetails",
        cdnaChange: item.proteinChange,
        geneName: item.geneName,
        type: "",
      };
      if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(param);
      } else {
        window.android.JSCallNative(JSON.stringify(param));
      }
    },
    // beforeRouteEnter(to, from, next) {
    //   window.NativeCallJS = (res) => {
    //     var par = JSON.parse(res);
    //     next((vm) => {
    //       console.log(par,'00000000011111')
    //     });
    //   };
    // },
  },
};
</script>
<style lang="less" scoped>
.null-p {
  text-align: center;
  padding: 24px;
  font-size: 16px;
}
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
  margin-bottom: 10px;
}
.openClass {
  overflow: hidden;
  height: 70px !important;
  transition: height 1s;
}
.relevant {
  padding: 20px 20px 102px;
  height: auto;
  // background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  .zhushi {
    border-radius: 10px;
    background: @background_color;
    .text {
      font-size: 13px;
      font-weight: 400;
      color: #5f697d;
      line-height: 24px;
      padding: 0 24px 24px;
    }
    h2 {
      height: 70px;
      font-size: 18PX;
      font-weight: 500;
      color: #2f354d;
      line-height: 70px;
      font-size: 15PX;
      position: relative;
      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  ._btn {
    text-align: center;
    position: fixed;
    bottom: 50px;
    left: 50%;
    margin-left: -68px;
    width: 136px;
    height: 32px;
    line-height: 32px;
    background: linear-gradient(270deg, #60adff 0%, #4b84ff 100%);
    box-shadow: 0px 4px 10px 0px rgba(75, 132, 255, 0.2);
    border-radius: 16px;
    outline: none;
    border: 0;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
    i {
      font-size: 10px;
    }
  }
  .text-content {
    font-size: 13px;
    font-weight: 400;
    color: #2f354d;
    /deep/.van-loading__text {
      color: #4b84ff;
    }
    /deep/.van-loading__spinner {
      color: #4b84ff;
    }
    .null-p {
      padding-bottom: 30px;
    }
    .byData {
      margin-bottom: 30px;
      background: @background_color;
      border-radius: 10px;
      margin-bottom: 20px;

      .flex-content {
        display: flex;
        padding: 0 24px;
        .l,
        .r {
          width: 50%;
        }
        .l {
          div {
            margin-bottom: 20px;
          }
        }
        .r {
          div {
            margin-bottom: 26px;
          }
        }
        p {
          font-size: 12px;
          font-weight: 400;
          color: #a4a9bf;
          line-height: 17px;
          margin-bottom: 4px;
        }
        h3 {
          font-size: 13px;
          font-weight: 500;
          color: #2f354d;
          line-height: 18PX;
        }
      }
      h2 {
        height: 70px;
        font-size: 18PX;
        font-weight: 500;
        color: #2f354d;
        line-height: 70px;
        font-size: 15PX;
        position: relative;
        padding: 0 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
          font-size: 12px;
          font-weight: 400;
          color: #4b84ff;
          line-height: 17px;
          i {
            margin-left: 4px;
            vertical-align: middle;
            margin-bottom: 3px;
          }
        }
        &::before {
          content: "";
          position: absolute;
          top: 50%;
          margin-top: -7px;
          left: 0;
          width: 3px;
          height: 14px;
          background: #2f354d;
          border-radius: 2px;
        }
      }
    }
  }
}
</style>
